/**
 * Máscaras de entrada que aceitam QUALQUER formato do usuário (com pontos,
 * traço, espaço, acento, letras perdidas, etc.) e reformatam em tempo real
 * pra o padrão brasileiro canônico. Submit time, `unmask*` retorna só dígitos.
 *
 * Estratégia: stripar tudo que não é dígito e reformatar pela posição. Isso
 * deixa o user livre pra colar "107.009.687-33" ou digitar "10700968733"
 * ou até "107 009 687 33" — resultado idêntico no backend.
 */

export function formatCPF(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) {
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  }
  return (
    `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-` +
    `${digits.slice(9, 11)}`
  );
}

/**
 * Celular brasileiro com ou sem código do país. Aceita:
 *   "27992743433"    → "(27) 99274-3433"
 *   "5527992743433"  → "+55 (27) 99274-3433"
 *   "(27) 99274-3433" → idem
 */
export function formatPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  // Com +55 (13 dígitos total: 2 país + 2 DDD + 9 número)
  if (digits.startsWith('55') && digits.length > 11) {
    const rest = digits.slice(2, 13);
    if (rest.length <= 2) return `+55 (${rest}`;
    if (rest.length <= 7) return `+55 (${rest.slice(0, 2)}) ${rest.slice(2)}`;
    return (
      `+55 (${rest.slice(0, 2)}) ${rest.slice(2, 7)}-${rest.slice(7, 11)}`
    );
  }
  // Sem código do país (DDD + 9 dígitos = 11 dígitos)
  const d = digits.slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7, 11)}`;
}

/** Retorna só dígitos pra submeter ao backend. */
export function unmaskDigits(formatted: string): string {
  return formatted.replace(/\D/g, '');
}
